import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import type { ClientsDashboardListAddress } from '@/types/clientDetailsApiTypes';

const numberFormatter = new Intl.NumberFormat('en-US');
const phoneUtil = PhoneNumberUtil.getInstance();

export function formatNumberWithCommas(value?: number | string | null) {
  const numberValue = Number(value);

  return Number.isFinite(numberValue) ? numberFormatter.format(numberValue) : '0';
}

export function formatAddressLine(a: ClientsDashboardListAddress) {
  const line1 = [a.client_mailing_address, a.client_mailing_address_line_2].filter(Boolean).join(' ');
  const tail = [a.client_mailing_city, a.client_mailing_state, a.zip_code].filter((p) => p && String(p).trim());
  const parts = [line1, ...tail].filter(Boolean);
  return parts.join(', ') || '—';
}

export function formatPhoneDisplay(phone: string) {
  const trimmed = phone.trim();
  if (!trimmed) return phone;

  const digits = trimmed.replace(/\D/g, '');

  if (digits.length === 11 && digits.startsWith('1')) {
    const national = digits.slice(1);

    return `+1 (${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;
  }

  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  try {
    const parsed = phoneUtil.parse(trimmed.startsWith('+') ? trimmed : `+${digits}`);

    if (phoneUtil.isPossibleNumber(parsed)) {
      return phoneUtil.format(parsed, PhoneNumberFormat.INTERNATIONAL);
    }
  } catch {
    return phone;
  }

  return phone;
}